export const module = {
  info: {
    name: 'voip-mrt-destinations',
    caption: 'voip mrt destinations',
    viewGroup: 'mrt-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'MRT Destinations',
    icon: 'el-icon-folder',
    routeName: 'create',
    children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-mrt-destinations->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-mrt-destinations->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
